import { createContext, useContext } from "react";
import { IPagerApi } from "../types/pager-api";

export const PageContext = createContext<IPagerApi | null>(null);

export const usePageContext = (): IPagerApi => {
  const ctx = useContext(PageContext);
  if (!ctx) {
    console.error("usePageContext must be used within PageContext.Provider");
    throw new Error("usePageContext must be used inside PageContext.Provider");
  }
  return ctx;
};
